module.exports = __webpack_public_path__ + "static/media/favorite.770318aa.svg";